import { render, staticRenderFns } from "./MasterSidebar.vue?vue&type=template&id=52e3816b&scoped=true"
import script from "./MasterSidebar.vue?vue&type=script&lang=js"
export * from "./MasterSidebar.vue?vue&type=script&lang=js"
import style0 from "./MasterSidebar.vue?vue&type=style&index=0&id=52e3816b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e3816b",
  null
  
)

export default component.exports